import type { ResolvedMonospaceCollection } from '#layers/data-model/public';
import { getCollectionPrimaryKeyFields } from '#layers/data-model/public';

export function initialSortState(collection: ResolvedMonospaceCollection) {
	const primaryKeyFields = getCollectionPrimaryKeyFields(collection);

	if (primaryKeyFields.length > 0) {
		return [{ fieldId: primaryKeyFields[0]!.id, direction: 'asc' as const }];
	}

	return [];
}
